import React, { useEffect } from 'react'
import { useUserContext } from '../../../_context/UserContext'
import { AddedCleaners } from '../AddCleaners/AddCleanerComponents/AddedCleaners'
import '../AddUsers/AddUsers.css'

export const ViewCleaners = () => {
  const { setCurrentPage } = useUserContext();

  useEffect(() => { setCurrentPage("View Cleaners"); }, []);

  return (
    <div className="au-card" style={{ margin: 0 }}>
      <div className="au-card-header">
        <div className="au-card-header-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 20l-7-7" /><path d="M9 3l-.5 9.5L4 18h16l-4.5-5.5L15 3H9z" />
          </svg>
        </div>
        <div>
          <p className="au-card-header-title">CNA Cleaners</p>
          <p className="au-card-header-sub">Browse and manage all registered cleaners</p>
        </div>
      </div>
      <div className="au-card-body">
        <AddedCleaners />
      </div>
    </div>
  );
};
